import React, { useState, useContext } from 'react';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import TextInput from '../../../sharedModules/form/components/TextInput';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

const InternalCommentsSection: React.FunctionComponent = () => {
  let { chillerLog, setChillerLog, saveCurrentLogToLocalStorage } = useContext(ChillerLogsContext);

  let [expanded, setExpanded] = useState(true);

  return (
    <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)} className="no-print">
      <AccordionSummary style={{ background: '#A21C37' }}>
        <h3 style={{ background: '#A21C37', color: '#fff', fontWeight: 700, padding: 5 }}>TUDI Private</h3>
      </AccordionSummary>
      <AccordionDetails style={{ margin: 0, padding: 0 }}>
        <Grid item xs={12}>
          <TextInput
            value={chillerLog?.internal_comment}
            valueChanged={(value) => setChillerLog((prevLog) => ({ ...prevLog, internal_comment: value }))}
            label={chillerLog?.internal_comment?.length > 0 ? 'Comment' : 'Enter your comments here...'}
            rows={5}
            multiline
            shrinkLabel={true}
            onBlur={saveCurrentLogToLocalStorage}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default InternalCommentsSection;
